"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tempAdmin = void 0;
var qs = require('qs');
// [Temp-Admin]
exports.tempAdmin = function (axios) {
    return {
        getAdminsTempPartnerExists: function (request) {
            return axios.get('/admins/temp/partner/exists', request);
        },
        getAdminsTempPartner: function (request) {
            return axios.get('/admins/temp/partner', request);
        },
        putAdminsTempPartner: function (request) {
            return axios.put('/admins/temp/partner', request.data);
        },
        getAdminsTempServiceExists: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/admins/temp/service/exists?" + query);
        },
        getAdminsTempService: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/admins/temp/service?" + query);
        },
        putAdminsTempService: function (request) {
            return axios.put('/admins/temp/service', request.data);
        },
        postAdminsTempServiceDepartments: function (request) {
            return axios.post('/admins/temp/service/departments', request.data);
        },
        postAdminsTempServiceJobDuties: function (request) {
            return axios.post('/admins/temp/service/job-duties', request.data);
        },
    };
};
